// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + {"310":"6613882d9dd2670ab86e","515":"ac554bcc54d428125e40"}[chunkId] + ".min.js";
};